/**
 * 付费弹窗全局状态
 */
import { create } from 'zustand';

interface PricingState {
  showPricingModal: boolean;
  openPricingModal: () => void;
  closePricingModal: () => void;
}

export const usePricingStore = create<PricingState>((set) => ({
  showPricingModal: false,
  openPricingModal: () => set({ showPricingModal: true }),
  closePricingModal: () => set({ showPricingModal: false }),
}));
